<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div>Data Catalogues</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3> Data Catalogue Management </h3>
  </span>
  <span class="toolbar-icon" >
    <img [routerLink]="['/data-catalogue/business-rules']" class="status-icon" src="assets/icons/list-status.svg" alt="status icon">
  </span>
</mat-toolbar>

<div class="catalogue-info-container">
  <h4><b>Catalogue:</b> {{latestCatalogVersion?.name}}</h4>
<!--  <div class="last-edited-container">-->
<!--    <div class="last-edited-item">-->
<!--      <div>Last edited by</div>-->
<!--      <div>john.doe</div>-->
<!--    </div>-->
<!--    <div class="last-edited-item">-->
<!--      <div>Last edited on</div>-->
<!--      <div>1 Feb 2025</div>-->
<!--    </div>-->
<!--  </div>-->
</div>

<div class="feature-box">
  <mat-form-field class="search-field clean-bottom-border" appearance="fill" >
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchText" placeholder="Search...">
  </mat-form-field>

  <div class="feature-list">
    <mat-list>
      <mat-list-item [routerLink]="['/data-catalogue/' + latestCatalogVersion.uuid + '/feature/' + feature?.label]" class="feature-list-item" *ngFor="let feature of filteredFeatures()">
        {{ feature?.label }}
      </mat-list-item>
    </mat-list>
  </div>
</div>
